











import { createComponent } from '@vue/composition-api';
import Device from '@/core/store/types/Device';

export default createComponent({
  props: {
    device: {
      type: Object as () => Device,
      required: true,
    },
  },
});
